import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Context Providers
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { BettingProvider } from './context/BettingContext';
import { LiveEventsProvider } from './context/LiveEventsContext';

import GlobalStyles from './styles/GlobalStyles';
import AppRouter from './AppRouter';
import AuthModal from './components/AuthModal';
import { useAuth } from './context/AuthContext';

// Helper component to connect Context to UI Modals
const AppContent = () => {
    const props = useAuth(); // Safely access context here
    // Destructure specifically to avoid issues if context is null (though Provider ensures it isn't)
    const showAuthModal = props?.showAuthModal || false;
    const setShowAuthModal = props?.setShowAuthModal || (() => { });
    const authView = props?.authView || 'login';

    return (
        <>
            <GlobalStyles />
            <ToastContainer theme="dark" position="top-right" />
            <AppRouter />
            <AuthModal
                isOpen={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                initialView={authView}
            />
        </>
    );
};

export default function App() {
    return (
        <BrowserRouter>
            <ErrorBoundary>
                <ThemeProvider>
                    <LanguageProvider>
                        <AuthProvider>
                            <ContextBridge>
                                <AppContent />
                            </ContextBridge>
                        </AuthProvider>
                    </LanguageProvider>
                </ThemeProvider>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

// Bridging Authentication into other Providers
const ContextBridge = ({ children }) => {
    const { user, userProfile } = useAuth();
    // Default currency to BS if not set
    const activeCurrency = userProfile?.activeCurrency || 'BS';

    return (
        <BettingProvider user={user} activeCurrency={activeCurrency}>
            <LiveEventsProvider>
                {children}
            </LiveEventsProvider>
        </BettingProvider>
    );
};
